<!--

	Clickable control with an arrow that changes direction
	depending on the expanded value.

-->

<template>
	<div class="mia-Expandable" @click.stop="onClick">
		<slot />
		<h3 :class="`glyphicon glyphicon-menu-${expanded?'up':'down'}`" />
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch, toNative } from "vue-facing-decorator";

@Component({
	emits: ["update:modelValue"],
})
export class Expandable extends Vue {
	@Prop({ required: true, type: Boolean }) protected modelValue!: boolean;

	expanded = false;

	@Watch("modelValue", { immediate: true })
	private onSet(value: boolean) {
		this.expanded = value;
	}

	onClick() {
		this.expanded = !this.expanded;
		this.$emit("update:modelValue", this.expanded);
	}
}

export default toNative(Expandable);
</script>

<style lang="scss">

.mia-Expandable {
	cursor: pointer;

	.glyphicon.glyphicon-menu-up,
	.glyphicon.glyphicon-menu-down {
		margin: theme.$mia-margin-size;
	}

	&:hover .glyphicon.glyphicon-menu-up,
	&:hover .glyphicon.glyphicon-menu-down {
		color: theme.$mia-color-buttonEncourage;
	}

	@media (min-width: theme.$screen-sm-min) {
		.glyphicon.glyphicon-menu-up,
		.glyphicon.glyphicon-menu-down {
			margin-left: theme.$mia-margin-size-xxl;
			margin-right: theme.$mia-margin-size-large;
		}
	}
}

</style>
